import TitleBar from '../../../../../components/TitleBar';
import { useParams } from 'react-router-dom';
import { Footer } from '../../../../../components/common/Footer';
import { MissionSummary } from '..';
import { Loading } from '../../../../../components';
import useBCPMetaData from '../../../../../hooks/useBCPMetaData';
import QueryErrorBoundary from '../../../../../components/error-handling';
import TitleUpdater from '../../../../../components/common/TitleUpdater';

export default function Mission() {
  const params = useParams();
  const { type, locationId } = params;

  const isLocationType = type === 'location';

  const { planUUID, locationName, loading, error } = useBCPMetaData(
    locationId!,
    isLocationType,
  );
  const backPath = `/bcp-landing/${type}/${locationId}`;

  return (
    <div>
      <TitleUpdater title={`Mission Statement & Scope`} />
      <TitleBar
        title="BCP Hub"
        subtitle="Mission Statement & Scope"
        brief={
          isLocationType
            ? 'Defining a clear objective and scope for the location’s Business Continuity Plan (BCP) is critical in ensuring that all relevant stakeholders are clear on the context in which mitigation strategies need to be developed.'
            : 'Defining a clear objective and scope for the company’s Business Continuity Plan (BCP) is critical in ensuring that all relevant stakeholders are clear on the context in which mitigation strategies need to be developed.'
        }
      />
      <QueryErrorBoundary error={error}>
        {!loading ? (
          <div className="mb-28 flex flex-col gap-3">
            <MissionSummary
              type={'objective'}
              planId={planUUID}
              title={`${
                isLocationType ? 'Location' : 'Corporate'
              } Business Continuity Objective`}
            />
            <MissionSummary
              type={'scope'}
              planId={planUUID}
              title={`${
                isLocationType ? 'Location' : 'Corporate'
              } Business Continuity Plan Scope`}
            />
          </div>
        ) : (
          <Loading />
        )}
      </QueryErrorBoundary>
      <Footer backPath={backPath} />
    </div>
  );
}
